// extracted by mini-css-extract-plugin
module.exports = {"root":"_2nvak0","imgPreviewWrapper":"_3blOFF","imgPreview":"_1T99P2","title":"zRTaPC"};